import { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import useMovement from './useMovement'
import { MAP_GRID, PLAYER_START, STOPS, TILE_IMAGES, TILE_SIZE } from './Data'
import StopPopup from './StopPopup'
import { STOP_CONTENT } from './AboutMe'
import fish from './assets/fish.png'
import resume from './assets/resume.png'

export default function Park({ onExit, avatar }) {
  const { pos, direction } = useMovement(MAP_GRID, PLAYER_START)
  const [currStop, setCurrStop] = useState(null)

  useEffect(() => {
    const stop = STOPS.find(s => s.r === pos.r && s.c === pos.c)
    setCurrStop(stop || null)
  }, [pos])

  const content = currStop ? STOP_CONTENT[currStop.id] : null // TODO stodgy but works for now

  const styles = {
    row: {
      display: 'flex',
      zIndex: 1,
    },
    park: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      justifyContent: 'center',
      zIndex: 1,
    },
    heading: {
      fontSize: '2.5rem',
      fontFamily: 'Courier, monospace',
      marginBottom: '1rem',
    },
    map: {
      borderRadius: '1.563rem',
      border: '0.938rem solid #F6CFD6',
      position: 'relative',
      overflow: 'visible',
      zIndex: 1,
    },
    stopLabel: {
      position: 'absolute',
      top: '-1.5rem',
      left: '50%',
      transform: 'translateX(-50%)',
      fontSize: '1rem',
      lineHeight: 1,
      fontFamily: 'Courier, monospace',
      fontWeight: 'bold',
      color: 'pink',
      textTransform: 'lowercase',
      whiteSpace: 'nowrap',
      pointerEvents: 'none',
      zIndex: 12,
      textShadow: '0 0.125rem 0.125rem rgba(0, 0, 0, 0.9)',
    },
    fish: {
      width: TILE_SIZE,
      height: TILE_SIZE,
      position: 'absolute',
      top: pos.r * TILE_SIZE + TILE_SIZE * 0.125, // 
      left: pos.c * TILE_SIZE + TILE_SIZE * 0.125,
      transform: direction === 'left' ? 'scaleX(-1)' : 'none', // TODO terrible way to fix sprite flipping around but works for now...
      zIndex: 5,
    },
    btn: {
      display: 'flex',
      justifySelf: 'center',
      fontSize: '1rem',
      fontWeight: 'bold',
      alignItems: 'center',
      color: '#000000ff',
      backgroundColor: '#F6CFD6',
      border: 'none',
      borderRadius: 4,
      hover: {
        backgroundColor: '#413C58',
        color: '#ffffffff',
      },
    },
  }

  return (
    <div className="park" style={styles.park}>
      <h3 style={styles.heading}>Use your arrow keys to explore.</h3>
      <p style={{ fontFamily: 'Courier, monospace', fontSize: '1.25rem', paddingBottom: '0.25rem' }}>Something's hiding in the shrubs!</p>
      <div className="park-map" style={styles.map}>
        <StopPopup open={!!content} title={content?.title || ''} body={content?.body || ''} onClose={() => setCurrStop(null)} />
        {MAP_GRID.map((row, rIdx) => (
          <div key={rIdx} className="park-row" style={styles.row}>
            {row.map((tile, cIdx) => {
              const stop = STOPS.find(currStop => currStop.r === rIdx && currStop.c === cIdx)

              return (
                <div
                  key={`${rIdx}-${cIdx}`}
                  title={stop?.id || ''}
                  style={{
                    width: TILE_SIZE,
                    height: TILE_SIZE,
                    margin: '0.063rem',
                    position: 'relative',
                    backgroundImage: `url(${TILE_IMAGES[tile] || TILE_IMAGES['.']})`,
                    backgroundSize: 'cover',
                  }}
                >
                  {stop && <span style={styles.stopLabel}>{stop.label}</span>}
                </div>
              )
            })}
          </div>
        ))}
        <img src={fish} alt="player" style={styles.fish} draggable={false} />
      </div>
      <div className="footer" style={{ position: 'absolute', display: 'flex', bottom: '0rem' }}>
        <Button id="resume" href="https://drive.google.com/file/d/1kPx5sZarQGinWZ1bftRO19-91blDlsDG/view?usp=sharing" style={{ ...styles.btn, marginRight: 50 }}
          onMouseOver={e => { e.currentTarget.style.backgroundColor = '#f4acb7'; }} onMouseOut={e => {
            e.currentTarget.style.backgroundColor = '#F6CFD6'
          }}>
          <img src={resume} alt="Resume" style={{ width: '2rem', height: '2rem', display: 'flex' }} />
        </Button>
        <Button onClick={onExit} aria-label="Exit the park"
          style={{ ...styles.btn }} onMouseOver={e => {
            e.currentTarget.style.backgroundColor = '#f4acb7';
          }} onMouseOut={e => {
            e.currentTarget.style.backgroundColor = '#F6CFD6';
          }}>
          exit
        </Button>
      </div>
    </div>
  )
}
